"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const classnames_1 = __importDefault(require("classnames"));
const SelectField = ({ label, options, ...props }) => {
    const [field, { touched, error }, helpers] = (0, formik_1.useField)(props.name);
    const id = props.id ? props.id : props.name;
    return (react_1.default.createElement("div", { className: "space-y-1" },
        react_1.default.createElement("label", { htmlFor: id, className: "block text-sm font-medium text-gray-700" }, label),
        react_1.default.createElement("select", { className: (0, classnames_1.default)("form-input", error ? '--error' : '', !field.value ? 'text-gray-500' : ''), ...props, ...field, value: field.value || "" },
            props.placeholder ? (react_1.default.createElement("option", { hidden: true, value: "" }, props.placeholder)) : null,
            options.map(option => (option.label ? (react_1.default.createElement("option", { value: option.value, key: option.value }, option.label)) : (react_1.default.createElement("option", { value: option, key: option }, option))))),
        touched && error ? react_1.default.createElement("p", { className: "mt-2 text-sm text-red-600", id: "email-error" }, error[0]) : ''));
};
exports.default = SelectField;
